import {Component} from '@angular/core';

@Component({
  selector: 'j4-loader',
  templateUrl: './j4-loader.component.html',
  styleUrls: ['./j4-loader.component.scss'],
  standalone: true
})
export class J4LoaderComponent {}
